import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import moment from "moment";

import { CommonService } from "../js_modules/CommonService";

import { SellToWebProgressbarComponent } from "../common/selltowebprogressbar/SelltoWebProgressbarComponent";
import { SellToWebTopPanelComponent } from "../common/selltowebtoppanel/SellToWebTopPanelComponent";
import { SellToWebRightPanelComponent } from "../common/selltowebrightpanel/SellToWebRightPanelComponent";
import { SellToWebButtonComponent } from "../common/selltowebbutton/SellToWebButtonComponent";

export class VehicleHistoryRouteComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirectTo: ""
        };

        this.onBackButtonClick = this.onBackButtonClick.bind(this);
        this.onVehicleConditionClick = this.onVehicleConditionClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
    }

    pageTitle = "Vehicle History";

    componentDidMount() {
        let homeData = CommonService.getSessionStorage("homeData");
        let vehicleDetailsData = CommonService.getSessionStorage("vehicleDetailsData");
        try {
            this.props.onPageLoad({ pageTitle: this.pageTitle });
            this.props.applicationInsights.trackPageView({ name: this.pageTitle, url: "/vehicle-history", pageType: "Consumer", isLoggedIn: "No", properties: { vin: homeData?.vin, vehicleId: vehicleDetailsData?.selectedTrim?.vehicleId, tenantName: this.props.tenantName, siteName: this.props.siteName } });
            if (!homeData || !vehicleDetailsData) {
                CommonService.clientAzureStorageLog("VehicleHistoryRouteComponent", "componentDidMount", "Session data missing.", "Redirect to unique-vehicle", null, null, this.props.applicationInsights);
                this.setState({ redirectTo: "/unique-vehicle" });
            }
            else {
                CommonService.clientAzureStorageLog("VehicleHistoryRouteComponent", "componentDidMount", homeData.vin, vehicleDetailsData.selectedTrim.vehicleId ?? vehicleDetailsData.selectedTrim.description.trim, null, null, this.props.applicationInsights);
            }
        }
        catch (error) {
            console.logError(error, "VehicleHistoryRouteComponent", "componentDidMount", homeData?.vin + " " + vehicleDetailsData?.selectedTrim?.vehicleId);
        }
    }

    onVehicleConditionClick() {
        try {
            this.setState({ redirectTo: "/vehicle-condition" });
        }
        catch (error) {
            console.logError(error, "VehicleHistoryRouteComponent", "onVehicleConditionClick");
        }
    }

    onBackButtonClick() {
        try {
            window.history.go(-1);
        }
        catch (error) {
            console.logError(error, "VehicleHistoryRouteComponent", "onBackButtonClick");
        }
    }

    onKeyDown(event) {
        if (event.keyCode === 13) {
            this.onVehicleConditionClick();
        }
    }

    render() {
        if (this.state.redirectTo) {
            return <Navigate to={this.state.redirectTo} />;
        }

        let homeData = CommonService.getSessionStorage("homeData");
        let vehicleDetailsData = CommonService.getSessionStorage("vehicleDetailsData");
        let headerHtml = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Vehicle History", "Default", "Header Html")?.Value;
        if (!headerHtml) {
            headerHtml = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Site", "Default", "Header Html")?.Value ?? "";
        }

        let footerHtml = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Vehicle History", "Default", "Footer Html")?.Value;
        if (!footerHtml) {
            footerHtml = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Site", "Default", "Footer Html")?.Value ?? "";
        }

        let bodyHtml = CommonService.getSiteAttributeValue(this.props.siteAttributes, "Vehicle History", "Default", "Body Html")?.Value ?? "";

        let accidentDetails = vehicleDetailsData ? vehicleDetailsData.autocheckData.accidentDetails : [];
        let accidentDetailsElement = [];
        accidentDetails.forEach((accidentDetail, index) => {
            accidentDetailsElement.push(<div style={{ border: "1px solid #dadada", marginBottom: "10px", alignItems: "center", display: "flex" }}>
                <div style={{ fontSize: "20px", backgroundColor: "rgba(0, 130, 236, 0.04)", borderRight: "1px solid #DCDCDC", padding: "15px 20px" }}>{index + 1}</div>
                <div style={{ fontSize: "12px", fontWeight: "500", paddingLeft: "20px", width: "130px" }} className="ac-vehiclehistory-accident-date">{moment(accidentDetail.date).format("MMMM DD, YYYY")}</div>
                <div style={{ fontSize: "15px", paddingLeft: "20px" }}>{accidentDetail.type}</div>
            </div>);
        });

        return <div className="ac-site ac-vehiclehistory">
            <header className="ac-site-header ac-vehiclehistory-header" dangerouslySetInnerHTML={{ __html: headerHtml }} />
            <SellToWebProgressbarComponent progressIndex={2} />
            <SellToWebTopPanelComponent imageUrl={vehicleDetailsData?.imageUrl} makePlusModel={vehicleDetailsData?.makePlusModel} trim={vehicleDetailsData?.selectedTrim?.trimName ?? "--"} />
            <section className="consumer-page">
                <section className="consumer-main">
                    <section className="ac-site-body ac-vehiclehistory-body" dangerouslySetInnerHTML={{ __html: bodyHtml }} />
                    <section className="ac-vehiclehistory-form" onKeyDown={(event) => this.onKeyDown(event)} tabIndex={-1}>
                        <figure style={{ textAlign: "center" }}>
                            <img src="images/autocheck.png" alt="autocheck" />
                        </figure>
                        {accidentDetailsElement}
                        <div className="d-flex justify-content-end">
                            <div style={{ "cursor": "pointer", "fontSize": "12px", "fontWeight": "400", "textDecoration": "underline", "margin": "auto 30px" }} onClick={(event => { window.history.go(-1); })}>
                                <span className="bi bi-chevron-left" style={{ "marginRight": "5px", "verticalAlign": "middle" }} />
                                Go Back
                            </div>
                            <SellToWebButtonComponent onClick={this.onVehicleConditionClick} value="Continue" />
                        </div>
                    </section>
                </section>
                <aside className="consumer-summary">
                    <SellToWebRightPanelComponent
                        vin={homeData?.vin} makePlusModel={vehicleDetailsData?.makePlusModel} valuationMethod={this.props.valuationMethod}
                        imageUrl={vehicleDetailsData?.imageUrl} differentColorShown={vehicleDetailsData?.differentColorShown} odometer={CommonService.formatMoney(vehicleDetailsData?.odometer)}
                        trim={(vehicleDetailsData?.selectedTrim?.trimName ?? vehicleDetailsData?.selectedTrim?.description?.trim) ?? "--"}
                        engine={vehicleDetailsData?.selectedEngine?.optionName ?? "--"}
                        transmission={vehicleDetailsData?.selectedTransmission?.optionName ?? "--"}
                        driveTrain={vehicleDetailsData?.selectedDriveTrain?.optionName ?? "--"}
                        colorBox={vehicleDetailsData?.selectedVehicleOEMColor?.colorBox ? CommonService.checkCSSColorSupports(vehicleDetailsData.selectedVehicleOEMColor.colorBox) : null}
                        colorName={vehicleDetailsData?.selectedVehicleOEMColor?.title ?? vehicleDetailsData?.selectedVehicleOEMColor?.optionName}
                        siteAttributes={this.props.siteAttributes} applicationInsights={this.state.applicationInsights}
                    />
                </aside>
            </section>
            <footer className="ac-site-footer ac-vehiclehistory-footer" dangerouslySetInnerHTML={{ __html: footerHtml }} />
        </div>;
    }
}